import { IDomain } from "@bprotsyk/aso-core";
import { useState } from "react";
import { Button, Input, Modal, Stack, Uploader, Message, toaster } from "rsuite";
import { uploadStatic, IStaticDeploy } from "../../../network/panel/network";
import "./_deploy-modal.scss";

export default function DeployModal({onClose}: {onClose: () => void}) {
  const [domain, setDomain] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const [isValidDomain, setIsValidDomain] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const checkARecord = async () => {
    if (!domain.trim()) {
      toaster.push(
        <Message type="error" showIcon>
          Будь ласка, введіть домен
        </Message>
      );
      return;
    }

    setIsChecking(true);
  

    try {
      // Використовуємо DNS over HTTPS API для перевірки A запису
      const response = await fetch(`https://dns.google/resolve?name=${domain}&type=A`);
      const data = await response.json();
      
      if (data.Answer && data.Answer.length > 0) {
        const ipAddress = data.Answer[0].data;
        if (ipAddress === "46.246.98.201") {
          setIsValidDomain(true);
          toaster.push(
            <Message type="success" showIcon>
              A запис правильний! Можна завантажувати файл.
            </Message>
          );
        } else {
          setIsValidDomain(false);
          toaster.push(
            <Message type="error" showIcon>
              A запис не правильний. Поточний IP: {ipAddress}, очікуваний: 46.246.98.201
            </Message>
          );
        }
      } else {
        setIsValidDomain(false);
        toaster.push(
          <Message type="error" showIcon>
            A запис не знайдено для цього домену
          </Message>
        );
      }
    } catch (error) {
      setIsValidDomain(false);
      toaster.push(
        <Message type="error" showIcon>
          Помилка при перевірці домену
        </Message>
      );
      console.error("DNS check error:", error);
    } finally {
      setIsChecking(false);
    }
  };

  const handleFileUpload = async (fileList: any[]) => {
    if (fileList && fileList.length > 0 && !isUploading) {
      const selectedFile = fileList[0].blobFile || fileList[0];
      setFile(selectedFile);
      
      // Автоматично завантажуємо файл після вибору
      await handleDeploy(selectedFile);
    }
  };

  const handleDeploy = async (fileToDeploy?: File) => {
    const fileToUse = fileToDeploy || file;
    if (fileToUse && domain && !isUploading) {
      setIsUploading(true);
      try {
        const deployData: IStaticDeploy = {
          file: [{ blobFile: fileToUse }],
          name: domain
        };
        
        toaster.push(
          <Message type="info" showIcon>
            Завантаження файлу...
          </Message>
        );

        const response = await uploadStatic(deployData);
        
        if (response && response.status === 200) {
          onClose();
        } else {
          toaster.push(
            <Message type="error" showIcon>
              Помилка при завантаженні файлу
            </Message>
          );
        }
      } catch (error) {
        console.error("Deploy error:", error);
        toaster.push(
          <Message type="error" showIcon>
            Помилка при завантаженні файлу
          </Message>
        );
      } finally {
        setIsUploading(false);
      }
    }
  };

  const resetModal = () => {
    setDomain("");
    setIsValidDomain(false);
    setFile(null);
    setIsUploading(false);
  };

  const handleClose = () => {
    resetModal();
    onClose();
  };

  return (
    <Modal open onClose={handleClose} backdrop={true} className="deploy-modal" size="sm">
      <Modal.Header className="deploy-modal-header">
        <Modal.Title>Деплой Статичних Файлів</Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="deploy-modal-body">
        <div className="step-container">
          <div className="input-group">
            <Input 
              value={domain} 
              onChange={(value) => setDomain(value)} 
              placeholder="Введіть домен для перевірки A запису"
              disabled={isChecking}
              className="domain-input"
            />
            <Button 
              onClick={checkARecord}
              loading={isChecking}
              disabled={!domain.trim() || isChecking || isValidDomain}
              className="check-btn"
              appearance="primary"
            >
              Перевірити
            </Button>
            <Uploader
              fileListVisible={false}
              listType="text"
              accept="*"
              onChange={handleFileUpload}
              draggable
              action=""
              className="file-uploader"
            >
              <Button 
                appearance={isValidDomain ? "primary" : "ghost"}
                className="upload-btn"
                disabled={!isValidDomain || isUploading}
                size="sm"
                loading={isUploading}
              >
                {!isUploading && <img src="/icons/upload-icon.svg" alt="Upload" className="upload-icon" />}
                {isUploading ? 'Завантаження...' : 'Файл'}
              </Button>
            </Uploader>
          </div>
          {file && (
            <div className="file-info">
              <p>Вибрано файл: <strong>{file.name}</strong></p>
            </div>
          )}
        </div>
      </Modal.Body>

    </Modal>
  );
}